import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { TranslateModule } from '@ngx-translate/core';
import { AppNotificationsService } from '@core/services/app-notifications.service';
import { AppNotification } from '@core/models/app-notification.model';

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatMenuModule, MatBadgeModule, TranslateModule],
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss']
})
export class NotificationBellComponent {
  readonly notifService = inject(AppNotificationsService);
  private readonly router = inject(Router);

  get notifications() { return this.notifService.notifications(); }
  get unreadCount() { return this.notifService.unreadCount(); }

  onMenuOpened(): void {
    this.notifService.load();
  }

  onItemClick(n: AppNotification): void {
    this.notifService.markAsRead(n.id);
    if (n.link) {
      this.router.navigate([n.link]);
    }
  }

  markAllRead(event: Event): void {
    event.stopPropagation();
    this.notifService.markAllAsRead();
  }

  iconColor(type: AppNotification['type']): string {
    switch (type) {
      case 'overdue': return 'var(--accent-red)';
      case 'due_soon': return '#f59e0b';
      case 'project_deadline': return '#3b82f6';
      case 'profile': return 'var(--accent-cyan)';
      default: return 'var(--text-secondary)';
    }
  }
}
